export default __webpack_public_path__ + "static/media/female-avtar3.0e7bb7ac.svg";